export const logoURL="https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/IMDB_Logo_2016.svg/2560px-IMDB_Logo_2016.svg.png";
export const POPULAR_API_URL = `https://api.themoviedb.org/3/movie/popular?api_key=${process.env.REACT_APP_API}&language=en-US`;
export const UPCOMING_API_URL = `https://api.themoviedb.org/3/movie/upcoming?api_key=${process.env.REACT_APP_API}&language=en-US`;
export const TOPRATED_API_URL = `https://api.themoviedb.org/3/movie/top_rated?api_key=${process.env.REACT_APP_API}&language=en-US`;
export const NOWPLAYING_API_URL = `https://api.themoviedb.org/3/movie/now_playing?api_key=${process.env.REACT_APP_API}&language=en-US`;

export const moviesType={
    upcoming : 'Upcoming',
    toprated : 'Top Rated',
    popular : 'Popular'
}